import React from 'react';
import InfoIcon from '@/icons/info.svg';
const statusConfig = {
    COMPLETED: {
        bg: '#30B78E',
        text: '#fff',
        label: 'Done'
    },
    ASSIGNED_TO_DRIVER: {
        bg: '#FFF2CC',
        text: '#524F47',
        label: 'Pending to start',
        showDot: true
    },
    DRIVER_IN_ORDER_FREE: {
        bg: '#F6FAFD',
        text: '#3C90DD',
        label: 'Started order',
        showDot: true
    },
    DRIVER_ARRIVED: {
        bg: '#E7F2FE',
        text: '#1777CF',
        label: 'Arrived',
        showDot: true
    },
    DRIVER_IN_ORDER_BUSY: {
        bg: '#93C37D1A',
        text: '#5DAC39',
        label: 'In ride',
        showDot: true
    },
    CANCELLED: {
        bg: '#999999',
        text: '#fff',
        label: 'Canceled'
    },
    REVIEW_REQUIRED: {
        bg: '#F5F5F5',
        text: '#757575',
        label: 'Pending review',
        showDot: true
    },
    WAITING_FOR_ACCEPT: {
        bg: '#FDF5EC',
        text: '#EE8F2B',
        label: 'Waiting to confirm',
        showDot: true,
        showInfo: true
    },
    ACCEPTED_BY_DRIVER: {
        bg: '#FFFCF0',
        text: '#F5B800',
        label: 'Confirmed by driver',
        showDot: true,
        showInfo: true
    }
};
const StatusTrip = ({ status }) => {
    var _a;
    const { bg, text, label, showDot, showInfo } = (_a = statusConfig[status]) !== null && _a !== void 0 ? _a : {
        bg: '#e2e1e1',
        text: '#fff',
        label: ''
    };
    return (React.createElement("div", { className: "status-trip", style: { background: bg, color: text } },
        showDot && React.createElement("span", { className: "status-trip-dot", style: { background: text } }),
        label,
        showInfo && React.createElement(InfoIcon, { fill: text, width: 10, height: 10 })));
};
export default StatusTrip;
